<template>
  <div>
    <v-layout>
      <v-flex xs12 sm12 md12 lg6 offset-lg3>
        <v-container fluid>
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="stepperCompleted1">{{ $t('newUser.STEP_PERSONAL') }}</v-stepper-step>
              <v-divider v-if="!isExpert"></v-divider>
              <v-stepper-step step="2" :complete="stepperCompleted2" v-if="!isExpert">{{ $t('newUser.STEP_SCHOOL') }}</v-stepper-step>
            </v-stepper-header>
            <div style="position: relative">
              <v-stepper-content step="1">
                  <v-layout wrap>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('user.NAME')"
                        v-model="newUser.name"
                        required></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('user.SURNAME_1')"
                        v-model="newUser.surname1"
                        required></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('user.SURNAME_2')"
                        v-model="newUser.surname2"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('user.USERNAME')"
                        v-model="newUser.username"
                        type="email"
                        :rules="emailRules"
                        required
                        validate-on-blur></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-select
                        v-bind:items="roles"
                        item-text="name"
                        item-value="id"
                        v-model="newUser.roleId"
                        :label="$t('user.USER_TYPE')"
                        required
                      >
                        <template slot="selection" slot-scope="data">{{ $t('role.'+data.item.name) }}</template>
                        <template slot="item" slot-scope="data">{{ $t('role.'+data.item.name) }}</template>
                      </v-select>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-select
                        v-bind:items="languages"
                        item-text="shortname"
                        item-value="id"
                        v-model="newUser.defaultLanguageId"
                        :label="$t('user.LANGUAGE')"
                        required
                      >
                        <template slot="selection" slot-scope="data">{{ $t('language.'+data.item.shortname) }}</template>
                        <template slot="item" slot-scope="data">{{ $t('language.'+data.item.shortname) }}</template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-btn flat disabled>{{ $t('forms.BACK') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn primary @click.native="submit"  :disabled="!stepperCompleted1" v-if="isExpert">{{ $t('newUser.SAVE_USER') }}</v-btn>
                    <v-btn primary @click.native="step = 2" :disabled="!stepperCompleted1" v-if="!isExpert">{{ $t('forms.CONTINUE') }}</v-btn>
                  </v-layout>
              </v-stepper-content>
              <v-stepper-content step="2">
                  <v-layout wrap>
                    <v-flex xs8 offset-xs2>
                      <v-select
                        v-bind:items="schools"
                        item-text="name"
                        item-value="id"
                        v-model="newUser.schoolId"
                        :label="$t('newUser.SCHOOL_NAME')"
                        autocomplete
                        required
                      >
                        <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
                        <template slot="item" slot-scope="data">{{ data.item.name }}</template>
                      </v-select>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('newUser.GRADO_MASTER')"
                        v-model="newUser.degree"
                        required></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('newUser.COURSE')"
                        v-model="newUser.course"
                        required></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-combobox
                        v-model="newUser.subjects"
                        :label="$t('newUser.SUBJECTS')"
                        :hint="$t('newUser.SUBJECTS_HINT')"
                        persistent-hint
                        append-icon=""
                        hide-no-data
                        deletable-chips
                        multiple
                        chips
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs8 offset-xs2 mt-2>
                      <v-text-field
                        :label="$t('newUser.STUDENTS_NUMBER')"
                        v-model="newUser.studentsNumber"
                        type="number"
                        required></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-btn flat @click.native="step = 1">{{ $t('forms.BACK') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn primary @click.native="submit"  :disabled="!stepperCompleted2">{{ $t('newUser.SAVE_USER') }}</v-btn>
                  </v-layout>
              </v-stepper-content>
            </div>
          </v-stepper>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {UserResource} from '../../api/user'
  import {LanguageResource} from '../../api/language'
  import {SchoolResource} from '../../api/school'
  import {RoleResource} from '../../api/role'

  export default {
    name: 'newUser',
    data () {
      return {
        newUser: {
          name: '',
          surname1: '',
          surname2: '',
          username: '',
          schoolId: '',
          degree: '',
          course: '',
          studentsNumber: '',
          defaultLanguageId: '',
          roleId: '',
          subjects: []
        },
        languages: [],
        schools: [],
        roles: [],
        step: 1,
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(v) || 'E-mail must be valid'
        ]
      }
    },
    mounted: function () {
      LanguageResource().get().then(
        response => {
          this.languages = response.data
        },
        response => {
          console.log('error in languages endpoint')
        }
      )
      SchoolResource().get().then(
        response => {
          this.schools = response.data
        },
        response => {
          console.log('error in schools endpoint')
        }
      )
      RoleResource().get().then(
        response => {
          this.roles = response.data
        },
        response => {
          console.log('error in roles endpoint')
        }
      )
    },
    computed: {
      stepperCompleted1: function () {
        return (this.newUser.name !== '' && this.newUser.surname1 !== '' && this.newUser.roleId !== '' && this.newUser.defaultLanguageId !== '' && this.newUser.username !== '' && this.validEmail)
      },
      stepperCompleted2: function () {
        return (this.stepperCompleted1 && this.newUser.schoolId !== '' && this.newUser.studentsNumber !== '' && this.newUser.degree !== '' && this.newUser.course !== '')
      },
      validEmail: function () {
        return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.newUser.username)
      },
      isExpert: function () {
        return (this.newUser.roleId !== '' && this.findItemById(this.roles, this.newUser.roleId).name === 'EXPERT')
      }
    },
    methods: {
      submit () {
        UserResource().save(this.newUser).then(response => {
          this.$router.push({ name: 'Users' })
        }, response => {
          this.$emit('showSnackbar', response.body.message)
          console.log(response)
        })
      },
      findItemById: function (collection, itemId) {
        return this._.find(collection, function (i) {
          return i.id === itemId
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/newUser.vue